import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch } from "util/router.js";
// import {loadOfferings} from 'store/actions/offeringsActions'
import {loadProducts } from 'store/actions/productActions'
import NewProductButton, {EditProductButton, DeleteProductButton} from 'components/NewProductButton';
import {Helmet} from 'react-helmet'
import Image from 'react-bootstrap/Image'
import moment from 'moment-timezone'
import ShareButton from 'components/ShareButton'
import PreviewImage from 'components/PreviewImage'

function ProductsTable(props) {

    const {challengeid} = props
    const products = useSelector(state => state.instructor.products.filter(val => val.location_type === "ondemand" && val.challengeId === challengeid))
    const widgetName = useSelector(state => state.instructor.instructor.widgetName)
    // console.log("reload packages table")
    const tableData = products.sort((a,b) => {
      return a.created - b.created
    }).map(val => {

      let shareLink = `https://sutrapro.com/${widgetName}/series/${challengeid}/on-demand/checkout/${val.platformID}`
      const preview = (
        <PreviewImage width={150} imageUrl={val?.images?.length > 0 ? val.images[0] : null} />
        // <div className="d-flex d-row align-items-center">
        //   <VideoPreviewImage width={150} imageUrl={val?.images?.length > 0 ? val.images[0] : null} />
        // </div>
      )

      var status = ""
      var color = ""
      if (val.hidden) {
        // yellow "#fbeeca"
        status = "Hidden"
        color = "#6c757d"
      } else if (val.expirationDate && val.expirationDate < moment().unix()) {
        status = "Expired"
        color = "#db7f6d"
      } else {
        status = "LIVE"
        color = "#dae8cc"
        // console.log("Expiration: ", val.expirationDate)
        // if (val.expirationDate) {
        //   status = status + " - Expires " + moment(val.expirationDate * 1000).format("LL")
        // } else {
        //   status = status + " - Expires Never"
        // }
      }

      const name = (
        <div className="d-flex d-row align-items-center">
          <div style={{
            backgroundColor: color,
            color: "black",
            borderRadius: "4px"
          }}
          className="px-2 py-1 mr-2"
          >
            {status}
          </div>
          <h6 className="mb-0 font-weight-bold">{val.name}</h6>
        </div>
      )

      const actions = (
        // we've added some custom button actions
        <div className="d-flex d-row justify-content-end">
            <ShareButton link={shareLink}
            style={{marginLeft: "-50px"}}
            />
            <EditProductButton 
            {...props}
            toEdit={val}
            productType="ondemand"
            />
            <DeleteProductButton 
            toDelete={val}
            productType="ondemand"
            />
        </div>
      )

      

      var categories = "None"
      if (val.categories) {
        categories = val.categories.join(", ")
      }

      return {
        ...val,
        name: name,
        preview: preview,
        price: `$${val.price}`,
        status: status,
        categories: categories,
        actions: actions
      }
  })

  return (
  <div>
      {tableData.length > 0 ? (
        <ReactTable
        data={tableData}
        filterable={false}
        columns={[
          {
            Header: "Preview",
            accessor: "preview",
            minWidth: 155
            },
            {
            Header: "Name",
            accessor: "name",
            minWidth: 150
            },
            // {
            // Header: "Hidden",
            // accessor: "sessions",
            // minWidth: 50
            // },
            {
            Header: "Categories",
            accessor: "categories",
            minWidth: 200
            },
            // {
            // Header: "Price",
            // accessor: "price",
            // width: 100
            // },
            // {
            // Header: "Status",
            // accessor: "status",
            // width: 100
            // },
            {
            Header: "Actions",
            accessor: "actions",
            sortable: false,
            width: 150
            // filterable: false
            }
        ]}
        defaultPageSize={10}
        showPaginationTop={false}
        showPaginationBottom={true}
        className="-highlight"
        />
      ) : (
        <div className="h-100 text-center">
          {/* <h3 className="font-weight-bold">Create a new package / sub</h3>
          <p>Get started now</p>
          <NewOfferingButton {...props}/> */}

        </div>
      )}

  </div>
  )
}


function OnDemandSection(props) {

  const { history, match } = props;
  const {challengeid} = props
  const dispatch = useDispatch();
  const partner = useSelector(state => state.instructor.instructor);
  const partnerId = partner?.platformID
  // useSelector(state => state.instructor.instructor.platformID);
  
  useEffect(() => {
    // dispatch
    if(partnerId) {
      dispatch(loadProducts())
    }
    
  }, [dispatch, partnerId]);

  
  

  // useEffect(() => {
  //   // dispatch
  //   console.log("new offerings")
  //   console.log(offerings)
    
  // }, [offerings]);

 


  function Products() {

    return (
    <div className="container px-0">

      <Helmet>
        <title>On Demand Videos</title>
      </Helmet>
      <section>
        <div className='d-flex d-row justify-content-between align-items-center mb-4'>
          <h2 className="font-weight-bold">On Demand</h2>
          <div>
            <NewProductButton productType="ondemand" className="w-100" {...props} />
          </div>
        </div>
        <p><big>Anyone who purchases and joins this series will have access to these on-demand videos</big></p>

        <ProductsTable
          {...props}
          history={history}
          baseUrl={match.url}
          // data={offerings}
          />
      </section>
    </div>
    );
  }

  return (
    <Products />
    // <Switch>
    //     <Route path="/">
          
    //     </Route>
    // </Switch>
  );
}

export default OnDemandSection;
